import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scan-rfid-card-image',
  templateUrl: './scan-rfid-card-image.component.html',
  styleUrls: ['./scan-rfid-card-image.component.css']
})
export class ScanRfidCardImageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
